import script from "./ProfileSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileSummary.vue?vue&type=script&setup=true&lang=js"

export default script